export const silentWitnessClasses = {
  itemCard:'bg-surface-light rounded-[6px] border border-border-light',

  groupHeader:'font-semibold text-content text-[1.1rem] border-b-2 border-border-light',

  itemNameWrapper:'grow min-w-0 pr-5',

  itemName:'text-[0.95rem] font-medium',

  checkboxGroup:'flex items-center gap-4',

  formControlLabel:'!mx-0 mb-0',

  labelText:'text-[0.9rem] font-medium',
};